import { FLOWCODE_MARKETING_BASE_URL, Routes } from '@dtx-company/true-common/src/constants/routes'
import { PlanLabel, PlanTileType } from './types'
import { PlanType } from '@dtx-company/true-common/src/types/planType'
import { createPlansPageUrl } from '../../../../../components/pages/Plans/createPlansPageUrl'

export const PLANS_UPGRADE_DIALOG_CONFIG: PlanTileType[] = [
  {
    planName: PlanLabel.PRO,
    header: 'PlansUpgradeDialog.ProTileHeader',
    subheader: 'PlansUpgradeDialog.ProTileSubheader',
    href: FLOWCODE_MARKETING_BASE_URL + '/pro'
  },
  {
    planName: PlanLabel.PRO_PLUS,
    header: 'PlansUpgradeDialog.ProPlusTileHeader',
    subheader: 'PlansUpgradeDialog.ProPlusTileSubheader',
    href: FLOWCODE_MARKETING_BASE_URL + '/proplus'
  },
  {
    planName: PlanLabel.ENTERPRISE,
    header: 'PlansUpgradeDialog.EnterpriseTileHeader',
    subheader: 'PlansUpgradeDialog.EnterpriseTileSubheader',
    href: FLOWCODE_MARKETING_BASE_URL + '/enterprise'
  }
]

export const NEXT_PLAN_TYPE: Record<PlanType, PlanType | null> = {
  [PlanType.FREE]: PlanType.PRO,
  [PlanType.PRO]: PlanType.PRO_PLUS_ORG,
  [PlanType.PRO_PLUS_ORG]: PlanType.PRO_FLEX,
  [PlanType.PRO_FLEX]: PlanType.ENTERPRISE,
  [PlanType.ENTERPRISE]: null
}

const getNextPlanHref = (planType: PlanType): string => {
  const nextPlanType = NEXT_PLAN_TYPE[planType]
  return nextPlanType ? Routes.BUY_PLAN_PAGE.replace('[planType]', nextPlanType) : ''
}

export const UPGRADE_TO_NEXT_PLAN_TILE_CONFIG: Record<PlanType, PlanTileType> = {
  [PlanType.FREE]: {
    planName: PlanLabel.NEXT_PLAN,
    header: 'PlansUpgradeDialog.NextProPlanTileHeader',
    subheader: 'PlansUpgradeDialog.NextProPlanTileSubheader',
    href: getNextPlanHref(PlanType.FREE)
  },
  [PlanType.PRO]: {
    planName: PlanLabel.PRO_PLUS,
    header: 'PlansUpgradeDialog.NextProPlusPlanTileHeader',
    subheader: 'PlansUpgradeDialog.NextProPlusPlanTileSubheader',
    href: getNextPlanHref(PlanType.PRO)
  },
  [PlanType.PRO_PLUS_ORG]: {
    planName: PlanLabel.PRO_PLUS,
    header: 'PlansUpgradeDialog.NextProPlusOrgPlanTileHeader',
    subheader: 'PlansUpgradeDialog.NextProPlusOrgPlanTileSubheader',
    href: getNextPlanHref(PlanType.PRO_PLUS_ORG)
  },
  [PlanType.PRO_FLEX]: {
    planName: PlanLabel.PRO,
    header: 'PlansUpgradeDialog.NextProPlanTileHeader',
    subheader: 'PlansUpgradeDialog.NextProPlanTileSubheader',
    href: getNextPlanHref(PlanType.PRO_FLEX)
  },
  [PlanType.ENTERPRISE]: {
    planName: PlanLabel.PRO,
    header: 'PlansUpgradeDialog.NextProPlanTileHeader',
    subheader: 'PlansUpgradeDialog.NextProPlanTileSubheader',
    href: getNextPlanHref(PlanType.ENTERPRISE)
  }
}

export const COMPARE_ALL_PLANS_TILE_CONFIG: PlanTileType = {
  planName: PlanLabel.COMPARE,
  header: 'PlansUpgradeDialog.CompareAllPlansTileHeader',
  subheader: 'PlansUpgradeDialog.CompareAllPlansTileSubheader',
  href: createPlansPageUrl().toString()
}
